import { chain } from "lodash";

import { type Label } from "@north-beam/nb-common";
import {
  type CommonTouchpointsMetrics,
  type PathElementFromResponse,
} from "@pages/objects/common-touchpoints";

export function aggregateRowsByLabelChoice(
  labelChoiceValue: string,
  unaggregatedRows: any[],
  adKeyHashToLabels: Record<string, Label[]>,
) {
  if (!labelChoiceValue) {
    return unaggregatedRows;
  }

  const descriptorToMetrics: Record<string, CommonTouchpointsMetrics> = {};
  for (const row of unaggregatedRows) {
    const {
      pathElements,
      numPaths,
      numConvertingPaths,
      revenueFromConvertingPaths,
    } = row;
    const descriptor = unorderedAdKeyPathToDescriptor(pathElements);
    const metrics = descriptorToMetrics[descriptor] ?? {
      numPaths: 0,
      numConvertingPaths: 0,
      revenueFromConvertingPaths: 0,
    };

    metrics.numPaths += numPaths;
    metrics.numConvertingPaths += numConvertingPaths;
    metrics.revenueFromConvertingPaths += revenueFromConvertingPaths;

    descriptorToMetrics[descriptor] = metrics;
  }

  const rv = [];
  for (const descriptor in descriptorToMetrics) {
    const metrics = descriptorToMetrics[descriptor];
    const pathElementsValues: string[] = JSON.parse(descriptor);
    rv.push({
      ...metrics,
      pathElements: pathElementsValues.map((value) => ({
        name: value || "(not set)",
        objectId: null,
        nbtPlatformID: null,
        platform: "",
        label: labelChoiceValue,
      })),
    });
  }
  return rv;

  function unorderedAdKeyPathToDescriptor(
    pathElements: PathElementFromResponse[],
  ) {
    const values: Record<string, true> = {};
    for (const { elementId } of pathElements) {
      const labels = adKeyHashToLabels[elementId];
      let value = "";
      if (labels) {
        const kv = labels.find((l) => l.key === labelChoiceValue);
        if (kv) {
          value = kv.value;
        }
      }

      values[value] = true;
    }

    return JSON.stringify(chain(values).keys().sortBy().value());
  }
}
